/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkDeleteItemObjectiveRequestSchema = z.object({
  itemIds: z.array(z.int()),
  objectiveId: z.int(),
});
